import styled from 'styled-components'

import Text from 'components/Atoms/Text'

const Buttons = styled.div`
  display: flex;
  margin-top: 20px;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}rem) {
    margin-top: 40px;
  }
`

const DownloadApp = styled(Text)`
  transition: opacity 0.3s;
  &:first-of-type {
    margin-right: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
`

const AppButtons = () => (
  <Buttons>
    <DownloadApp
      as="a"
      target="_blank"
      href="https://itunes.apple.com/us/app/citifyd/id984113093?ls=1&mt=8">
      <img
        width="100%"
        alt="App Store badge"
        src={'/static/images/app_store_badge.png'}
      />
    </DownloadApp>
    <DownloadApp
      as="a"
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.citifyd.Citifyd">
      <img
        width="100%"
        alt="Google play badge"
        src={'/static/images/google_play_badge.png'}
      />
    </DownloadApp>
  </Buttons>
)

export default AppButtons
